/**
 * Created by jv on 18/01/2017.
 */
const utils = require("Sources/utils/utils");
const Person = require("Sources/models/person");
const Organisation = require("Sources/models/organisation");

module.exports = class Contact
{
  constructor(options)
  {
    options = utils.isNotNull(options) ? options : {};

    this.type = options.type;
    this.person = options.person;
    this.organisation = options.organisation;
  };

  set person(person)
  {
    this._person = new Person(person);
  };

  get person()
  {
    return this._person;
  }

  set organisation(organisation)
  {
    this._organisation = new Organisation(organisation);
  };

  get organisation()
  {
    return this._organisation;
  };
};



// WEBPACK FOOTER //
// ./app/js/models/contact.js